import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import "./visitStatusDropdown.css";

const VisitStatusDropdown = ({ value, onChange, options = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value) || options[0];

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const handleSelect = (v) => {
    onChange(v);
    setIsOpen(false);
  };

  return (
    <div className="vsd-wrapper" ref={ref}>
      <button
        type="button"
        className={`vsd-trigger ${isOpen ? "vsd-trigger--open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="vsd-prefix">Status</span>
        <span className="vsd-label">{selected?.label}</span>
        <ChevronDown size={16} className={`vsd-chevron ${isOpen ? "vsd-chevron--open" : ""}`} />
      </button>

      {isOpen && (
        <div className="vsd-menu">
          {options.map((option) => (
            <button
              type="button"
              key={option.value}
              className={`vsd-option ${value === option.value ? "vsd-option--active" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="vsd-option-label">{option.label}</span>
              {value === option.value && <span className="vsd-check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default VisitStatusDropdown;